/*------------------------------------------------------------------
Document Setup
------------------------------------------------------------------*/

// Store the imported scripts using a Set for uniqueness and faster lookups
const imported = new Set();
// Get the context of the blocks folder
const context = require.context('./blocks', true, /\.js$/);
// List the required blocks and their paths
const blocks = {
  '.js-default-accordion': './default/accordion',
  '.js-default-tabbed-content': './default/tabs',
  '.js-default-slider': './default/slider',
  '.js-default-gallery': './default/gallery',
  '.js-default-testimonial': './default/testimonial',
  '.js-default-motif': './default/motif',
  '.js-default-map': './default/map',
  '.js-default-audio': './default/audio',
  '.js-default-link': './default/link',
  '.js-default-casestudies': './default/casestudies',
  '.js-motif-text': './motif/text',
  '.js-motif-media-text': './motif/media-text',
  '.js-motif-hero': './motif/hero',
  '.js-focus-hero': './focus/hero',
  '.js-action-hero': './action/hero',
  '.js-stacked-children': './stacked/children',
  '.js-slider-link': './slider/link'
};

// Function to import a block script
function importBlock(selector, path) {
  if (imported.has(path)) return;
  imported.add(path);
  try {
    context(`${path}.js`);
  } catch (error) {
    console.warn('Error importing block: ', selector);
    console.error(error);
  }
}

// Initialize block watchers
function initBlockWatchers() {
  console.log("%cblocks", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #f7ebde");
  Object.entries(blocks).forEach(_ref => {
    let [selector, path] = _ref;
    Watcher.observe(selector, () => importBlock(selector, path));
  });
}

// Initialize the block watchers when the document is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlockWatchers);
} else {
  initBlockWatchers();
}